import { useEffect } from "react";
import { useSetState } from "ahooks";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import CopyToClipboard from "react-copy-to-clipboard";
import Main from "../../components/main";
import Header from "../../components/header";
import Content from "../../components/content";
import MyScroll from "../../components/myScroll";
import Empty from "../../components/empty";
import FilterModal from "./filterModal";
import { http, httpGet } from "../../services/fetcher";
import api from "../../services/api";
import { classNames, getTime } from "../../tool";
import styles from "./index.module.scss";
import dayjs from "dayjs";
import toast from "../../components/toast";
const dateListMap = {
  0: "今天",
  1: "昨天",
  6: "近7日",
  14: "近15日",
  29: "近30日",
};
function Order({ store }) {
  const { playInfo, setPlayInfo } = store || {};
  const playInfoJs = toJS(playInfo) || {};

  const rules =
    (JSON.parse(playInfoJs.playInfo || "{}").LHC || {}).playInfo || [];
  const [state, setState] = useSetState({
    data: [],
    formatData: [],
    noUp: false,
    current: 1,
    refreshCount: 1,
    dateVisible: false,
    date: "",
    cacheDate: "0",
    stateIndex: 0,
  });
  const {
    data,
    formatData,
    noUp,
    current,
    refreshCount,
    dateVisible,
    date,
    cacheDate,
    stateIndex,
  } = state;
  // 获取历史开奖信息
  const queryData = async (params) => {
    const res = await http(api.historyOrder, params);
    if (res.code === "C2") {
      const records = res.result.records;
      const total = res.result.total;
      const isLast =
        (current - 1) * 10 + (records || []).length === (total || 0);
      let arr = [];
      if (current === 1) {
        arr = records;
      } else {
        arr = data.concat(records || []);
      }
      setState({ noUp: isLast, data: arr });
    }
  };
  useEffect(() => {
    // 默认请求历史开奖
    let params = {
      state: stateIndex,
      page: {
        current,
        size: 10,
      },
    };
    if (date) {
      const time = getTime(date);
      params = {
        ...params,
        startTime: time.start,
        endTime: time.end,
      };
    }
    queryData(params);
  }, [current, refreshCount, date, stateIndex]);

  const getPlayItem = (item) => {
    const { playCode2, playCode3, betContent } = item;
    let plays = [];
    rules.forEach((i) => {
      if (i.code === playCode2) {
        if (i.plays) {
          plays = i.plays;
        } else {
          const secondPlay =
            i.children.find((it) => it.code === playCode3) || {};
          plays = secondPlay.plays || [];
        }
      }
    });
    const betContentFromat = plays.length
      ? betContent.map((it) => {
          const item = plays.find((i) => i.code === it);
          return item ? item.name : it;
        })
      : betContent;
    return betContentFromat;
  };

  useEffect(() => {
    // 请求玩法规则
    const getPlayInfo = async () => {
      const res = await httpGet(api.playInfo);
      if (res.code === "C2") {
        setPlayInfo(res.result);
      }
    };
    if (rules.length === 0) {
      getPlayInfo();
    }
  }, []);
  useEffect(() => {
    if (rules.length) {
      const newData = (data || []).map((item) => {
        return {
          ...item,
          betContentFromat: getPlayItem(item),
        };
      });
      setState({
        formatData: newData,
      });
    }
  }, [rules.length, data.length, refreshCount, date]);
  const onRefresh = () => {
    setState({
      current: 1,
      noUp: false,
      refreshCount: refreshCount + 1,
    });
  };
  const onGetMore = () => {
    setState({
      current: current + 1,
    });
  };
  const renderItem = (item, index) => {
    const {
      issueId,
      ctime,
      betAmount,
      playCode2Name,
      playCode3Name,
      lotteryResult,
      rowId,
      betContentFromat,
      gameAmount,
      status,
      betOdds,
    } = item;
    return status === 0 ? (
      <div
        className={classNames(styles.orderItem, styles.orderItem0)}
        key={index}
      >
        <div className={styles.topContent}>
          <div className={styles.title}>
            <div className={styles.lotteryName}>彩票-澳门六合彩</div>
            <div className={classNames(styles.status, styles.status0)}>
              未结算
            </div>
          </div>
          <div className={styles.betContainer}>
            <div className={styles.label}>投注项：</div>
            <div className={styles.value}>
              <span className={styles.playCode3Name}>
                {playCode3Name || playCode2Name}
              </span>
              <div className={styles.betContentPlays}>
                {betContentFromat &&
                  betContentFromat.map((i, idx) => {
                    return `${
                      playCode2Name === "尾数" && playCode3Name === "尾数"
                        ? `${i}尾`
                        : i
                    }${idx < betContentFromat.length - 1 ? "," : ""}`;
                  })}
              </div>
              <span className={styles.odds}>@{betOdds}</span>
            </div>
          </div>
          <div className={styles.betIssue}>
            <div className={styles.label}>
              <div className={styles.issueLable}>
                <span>期</span>
                <span>号：</span>
              </div>
            </div>
            <div className={styles.value}>{issueId}</div>
          </div>
        </div>

        <img
          className={styles.divider}
          src={require("../../assets/imgs/new/border.png")}
        />

        <div className={styles.bottomContent}>
          <div className={styles.betAmount}>
            <div className={styles.label}>投注额：</div>
            <div className={styles.value}>
              <span className={styles.betAmountText}>{betAmount}</span>
              (CNY)
            </div>
          </div>
          <div className={styles.bottom}>
            <div className={styles.orderId}>
              <div className={styles.label}>注单号：</div>
              <div className={styles.value}>
                <div className={styles.orderText}>
                  <div className={styles.rowId}>{rowId}</div>
                  <CopyToClipboard
                    text={rowId}
                    onCopy={() => toast("复制成功")}
                  >
                    <div className={styles.copyBtn}></div>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div className={styles.time}>
              {dayjs(ctime).format("MM-DD HH:mm:ss")}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        className={classNames(styles.orderItem, styles.orderItem1)}
        key={index}
      >
        <div className={styles.topContent}>
          <div className={styles.title}>
            <div className={styles.lotteryName}>澳门六合彩</div>
            <div
              className={classNames(
                styles.gameAmount,
                gameAmount < 0 ? styles.lose : ""
              )}
            >
              {gameAmount <= 0 ? gameAmount : "+" + gameAmount}
            </div>
          </div>
          <div className={styles.settle}>
            <div className={styles.result}>开：{lotteryResult.join("，")}</div>
            <div className={classNames(styles.status, styles.status1)}>
              已结算
            </div>
          </div>
          <div className={styles.betContainer}>
            <div className={styles.label}>投注项：</div>
            <div className={styles.value}>
              <span className={styles.playCode3Name}>
                {playCode3Name || playCode2Name}
              </span>
              <div className={styles.betContentPlays}>
                {betContentFromat &&
                  betContentFromat.map((i, idx) => {
                    return (
                      <span key={i}>
                        {playCode2Name === "尾数" && playCode3Name === "尾数"
                          ? `${i}尾`
                          : i}
                        {idx < betContentFromat.length - 1 ? "," : ""}
                      </span>
                    );
                  })}
              </div>
              <span className={styles.odds}>@{betOdds}</span>
            </div>
          </div>
          <div className={styles.betIssue}>
            <div className={styles.label}>
              <div className={styles.issueLable}>
                <span>期</span>
                <span>号：</span>
              </div>
            </div>
            <div className={styles.value}>{issueId}</div>
          </div>
        </div>
        <img
          className={styles.divider}
          src={require("../../assets/imgs/new/border.png")}
        />
        <div className={styles.bottomContent}>
          <div className={styles.betAmount}>
            <div className={styles.label}>投注额：</div>
            <div className={styles.value}>
              <span className={styles.betAmountText}>{betAmount}</span>
              (CNY)
            </div>
          </div>
          <div className={styles.bottom}>
            <div className={styles.orderId}>
              <div className={styles.label}>注单号：</div>
              <div className={styles.value}>
                <div className={styles.orderText}>
                  <div className={styles.rowId}>{rowId}</div>
                  <CopyToClipboard
                    text={rowId}
                    onCopy={() => toast("复制成功")}
                  >
                    <div className={styles.copyBtn}></div>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div className={styles.time}>
              {dayjs(ctime).format("MM-DD HH:mm:ss")}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Main>
      <Header title="投注记录" className={styles.header}></Header>
      <div className={styles.selectHeader}>
        <div className={styles.timeSelect}>
          <span
            className={classNames(
              styles.timeBtn,
              date === "" ? styles.active : ""
            )}
            onClick={() =>
              setState({
                date: "",
              })
            }
          >
            全部
          </span>
          <span
            className={classNames(
              styles.timeBtn,
              date === cacheDate ? styles.active : ""
            )}
            onClick={() => {
              if (!date) {
                setState({
                  date: cacheDate,
                });
              }
            }}
          >
            {dateListMap[cacheDate ? cacheDate : "0"]}
          </span>
        </div>
        <div
          className={styles.filter}
          onClick={() => {
            setState({
              dateVisible: true,
            });
          }}
        >
          <img src={require("../../assets/imgs/new/filter.png")} />
          筛选
        </div>
      </div>
      <Content className={styles.content}>
        <div className={styles.stateSelect}>
          <div
            className={classNames(
              styles.stateItem,
              stateIndex === 0 ? styles.active : ""
            )}
            onClick={() => {
              setState({
                stateIndex: 0,
              });
            }}
          >
            待结算
          </div>
          <div
            className={classNames(
              styles.stateItem,
              stateIndex === 1 ? styles.active : ""
            )}
            onClick={() => {
              setState({
                stateIndex: 1,
              });
            }}
          >
            已结算
          </div>
        </div>
        <div className={styles.scrollContent}>
          {formatData.length === 0 ? (
            <Empty />
          ) : (
            <MyScroll
              id="order"
              iscrollOptions={{
                preventDefault: false,
                mouseWheel: true,
                eventPassthrough: "horizontal",
              }}
              hideNoUpStr={true}
              noUp={noUp}
              onDown={onRefresh}
              onUp={onGetMore}
            >
              {formatData.map((item, index) => {
                return renderItem(item, index);
              })}
            </MyScroll>
          )}
        </div>
      </Content>
      <FilterModal
        visible={dateVisible}
        value={[stateIndex, date]}
        onConfirm={([state, time]) => {
          setState({
            stateIndex: state,
            date: time,
            cacheDate: time ? time : "0",
          });
        }}
        onClose={() => setState({ dateVisible: false })}
      />
    </Main>
  );
}

export default inject("store")(observer(Order));
